import React, { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import moment from "moment";
import { TabbedPanelE10x } from "../../components/tabbedPanel/tabbed_panel";
import MainPageDialog from "../../components/dialog";
import { AppListing } from "../../components/AppListing/Listing.view";
import LoadingBars from "../../components/loadingBar";
import { useGetAppointmentsOnConditionQuery } from "../../services/appointmentService";

export const appointmentCols = [
  {
    title: "Date",
    key: "formated_datetime",
    colWidth: "1",
    getData: (item) => {
      if (item?.formated_datetime) {
        return <p>{moment(item?.formated_datetime).format("MM/DD/YYYY")}</p>;
      }
    },
  },
  {
    title: "Duration",
    key: "duration",
    colWidth: "2",
    getData: (item) => {
      if (item) {
        return (
          <div className="flex flex-col">
            <p>{`${item?.startTime_ampm} - ${item?.endTime_ampm} (${item?.duration} min)`}</p>
            <p>{item?.location_name}</p>
          </div>
        );
      }
    },
  },
  { title: "Reason", key: "reason_title", colWidth: "1" },
  { title: "Status", key: "status", colWidth: "1" },
  { title: "Type", key: "appointment_type_title", colWidth: "1" },
  {
    title: "Appointment with",
    key: "appointment_with",
    colWidth: "2",
    getData: (item) => {
      if (item?.providers[0]?.name) {
        return <p>{item?.providers[0]?.name}</p>;
      }
    },
  },
  { title: "Created by", key: "created_by_name", colWidth: "2" },
  { title: "Updated by", key: "updated_by_name", colWidth: "2" },
];

const AllAppointments = ({
  setOpenAppointmentsListingDialogue,
  shareDataDetail,
  selectedChat
}) => {
  let [selectedTableData,setSelectedTableData] = useState([]);
  const footerList = [
    shareDataDetail && {
      type: "save",
      action: () => shareDataDetail?.attachHandler(selectedTableData),
      title: "Attach",
    },
    {
      type: "cancel",
      action: () =>
        shareDataDetail
          ? shareDataDetail?.closeDialog()
          : setOpenAppointmentsListingDialogue(false),
      title: "Close",
    },
  ];

  const appointmentsTabs = [
    {
      title: "Current Appointments",
      type: "current_appointments",
      active: true,
    },
    {
      title: "Past Appointments",
      type: "past_appointments",
      // active: true,
    },
  ];

  const [currentTab, setCurrentTab] = useState(appointmentsTabs[0]);


  const { data: appointmentsListDataCurrent, isLoading: currentLoading } =
    useGetAppointmentsOnConditionQuery({
      pid: selectedChat?.pid,
      page: 1,
      patient_chart: 1,
      past_only: undefined,
      type: "appointments",
    });

  const { data: appointmentsListDataPassed, isLoading: pastLoading } =
    useGetAppointmentsOnConditionQuery({
      pid: selectedChat?.pid,
      page: 1,
      patient_chart: 1,
      past_only: 1,
      type: "appointments",
    });

  const selectGroup = (tab) => {
    setCurrentTab(tab);
  };

  return (
    <div>
      <MainPageDialog
        title="All Appointments"
        onCancelHandler={() =>
          shareDataDetail
            ? shareDataDetail?.closeDialog()
            : setOpenAppointmentsListingDialogue(false)
        }
        footer={true}
        footerList={footerList}
      >
        <div className="min-h-[45vh]">
          <div className="flex flex-row -ml-2 -mr-2">
            <div className="flex flex-row justify-between items-center gap-x-2.5 bg-gray-c-120 pt-2 px-5 min-h-800 -mt-2 border-b w-full border-gray-200">
              <>
                <TabbedPanelE10x
                  tabs={appointmentsTabs}
                  onTabChange={selectGroup}
                />
              </>
            </div>
          </div>
          {currentLoading || pastLoading ? (
            <LoadingBars />
          ) : (
            <div className="mt-2 text-left">
              <AppListing
                listData={
                  currentTab?.type === "current_appointments"
                    ? appointmentsListDataCurrent?.appointments
                    : appointmentsListDataPassed?.appointments
                }
                selection={shareDataDetail ? true : false}
                cols={appointmentCols}
                listContainerCls="app-list-container-default"
                toggleSelectItem={(data) => {
                  setSelectedTableData(null)
                  setSelectedTableData(data);
                }}
              />
            </div>
          )}
        </div>
      </MainPageDialog>
    </div>
  );
};

export default AllAppointments;
